import { render, staticRenderFns } from "./AppNoticeList.vue?vue&type=template&id=44519ff9&"
import script from "./AppNoticeList.vue?vue&type=script&lang=js&"
export * from "./AppNoticeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports